import DataTable from "react-data-table-component";
import sortedArrayRemoveDuplicates from "./sortedArrayRemoveDuplicates";
import createCsvURL from "./convertToCSV";

const TableAvailabilityView = ({clinicians, events}) => {

	const clinicianIDs = 
		sortedArrayRemoveDuplicates( events.flatMap(e => {
			const clinIDs = [...(e.ClinicianPartyIDs)?? [], e.PartyID?? 0];
			return clinIDs;
		}).toSorted((a, b) => a - b) )
		.filter( v => 0 !== v);

	const cliniciansInSlotsCols = 
		clinicians.filter(c => clinicianIDs.includes( c.ClinicianPartyID ))
		.map(c => ({ 
			name: 		c.FirstName + ' ' + c.LastName,
			selector: 	row => row.ClinicianPartyIDs?.includes?.( c.ClinicianPartyID )? 'Available': '',
			sortable: 	false
		}));

	const columns = [
		{
			name: 'Date And Time',
			selector:	row => row.start,
			sortable: true,
			minWidth: '14em'
		},
		...cliniciansInSlotsCols
	];

	const availabilityEvents = events.filter(e => 'availability' === e.type);
 
    return <>
        <DataTable columns={columns} data={availabilityEvents} fixedHeader={true} fixedHeaderScrollHeight={'50ex'} /> 
		<a href={createCsvURL(availabilityEvents, columns)} download={'export.csv'}  >Download as CSV</a>
    </>
}

export default TableAvailabilityView;